// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}
.container-smart-component {
  padding: 0;
  padding-block-start: 30px;
  line-height: 0.9;
  text-transform: uppercase;
  font-weight: 600;
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
  font-weight: 700;
  color: var(--ion-color-primary);
  background-color: #E9E9E9;
  padding: 10px;
  width: 100%;
  position: relative;
}

.title::before {
  content: "ROOM";
  position: absolute;
  top: -18px;
  left: 10px;
  color: #E9E9E9;
  font-size: 20px;
}

.container-spinner {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
  width: 100%;
}

.content {
  padding: 10px;
}
.content > * + * {
  margin-block-start: 40px;
}
.content .guest {
  margin-block-start: 10px;
}

.date-hour {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  font-size: 20px;
  margin-block-start: 30px;
}
.date-hour span:first-of-type {
  color: #BCBCBC;
}

ion-icon {
  font-size: 35px;
  color: #BCBCBC;
  flex-shrink: 0;
}

.accesses {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: calc(100% - 40px);
  flex-direction: column;
  border: 1px solid #E9E9E9;
  border-radius: 10px;
  padding: 5px 15px;
}
.accesses > span {
  color: #BCBCBC;
}
.accesses .access:not(:nth-last-of-type(1)) {
  border-bottom: 1px solid #E9E9E9;
}

.access {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-self: flex-start;
  gap: 10px;
  padding: 20px 10px;
  width: 100%;
}
.access > span {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  gap: 10px;
}
.access > span > span {
  color: #BCBCBC;
}

.enter,
.leave {
  text-transform: none;
}
.enter ion-icon,
.leave ion-icon {
  font-size: 25px;
  color: white;
}
.enter > div,
.leave > div {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-inline-end: 10px;
}

.enter > div {
  background-color: #1FA67B;
}

.leave > div {
  background-color: #A61F1F;
}

.guest {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: max-content;
  max-width: calc(100% - 40px);
  justify-content: flex-start;
  border: 1px solid #E9E9E9;
  border-radius: 10px;
  padding: 5px 10px;
}
.guest div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-inline: 30px 40px;
  flex-direction: column;
  gap: 3px;
}
.guest div span:first-of-type {
  color: #BCBCBC;
}
.guest div span:nth-of-type(2) {
  text-transform: none;
  color: #787878;
}
.guest .on {
  color: #1FA67B;
}
.guest ion-icon {
  font-size: 45px;
  color: #A61F1F;
}

.buttons {
  display: flex;
  justify-content: space-evenly;
}
.buttons > div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
  font-weight: 700;
  gap: 6px;
}

ion-button {
  --border-radius: 50%;
  --padding-start: 0;
  --padding-end: 0;
  width: 60px;
  height: 60px;
  --background: #E9E9E9;
  --box-shadow: 0;
  --ripple-color: var(--ion-color-primary);
  --transition: transform .2s ease-out;
  color: #92949c;
}
ion-button.button-large {
  width: 110px;
  height: 110px;
  margin-inline: auto;
  display: block;
  --background: radial-gradient(circle, rgba(255, 255, 255, 1) 48%, rgba(233, 233, 233, 1) 100%);
  color: var(--ion-color-primary);
  --box-shadow: 2px 2px 5px -1px #b3b3b3, 0px 0px 0px 16px #F9F9F9, 0px 0px 8px 18px #EAEAEA;
}
ion-button.button-large ion-icon {
  font-size: 50px;
  color: var(--ion-color-primary);
}
ion-button.active {
  transform: scale(1.2);
}
ion-button.turn-on {
  color: white;
  --background: var(--ion-color-primary) ;
}
ion-button ion-icon {
  font-size: 45px;
}

.toggle-button {
  display: block;
  font-size: 24px;
  cursor: pointer;
  margin-inline: auto;
  margin-block-start: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-room/widget-room.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAQA;ECPI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADCJ;ACCI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADCR;ACEI;EACI,UAAA;ADAR;AAhBA;EAEE,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAiBF;;AAdA;EAdE,aAAA;EACA,uBAAA;EACA,mBAAA;EAcA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AAmBF;;AAhBA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAmBF;;AAhBA;ECoBI,kFAAA;EACA,WAAA;ADAJ;;AAjBA;EACE,aAAA;AAoBF;AAlBE;EACE,wBAAA;AAoBJ;AAjBE;EACE,wBAAA;AAmBJ;;AAfA;EAlDE,aAAA;EACA,uBAAA;EACA,mBAAA;EAkDA,SAAA;EACA,eAAA;EACA,wBAAA;AAoBF;AAlBE;EACE,cAAA;AAoBJ;;AAhBA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAmBF;;AAhBA;EAnEE,aAAA;EACA,uBAAA;EACA,mBAAA;EAmEA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AAqBF;AAnBE;EACE,cAAA;AAqBJ;AAlBE;EACE,gCAAA;AAoBJ;;AAhBA;EArFE,aAAA;EACA,uBAAA;EACA,mBAAA;EAqFA,sBAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;AAqBF;AAnBE;EA7FA,aAAA;EACA,uBAAA;EACA,mBAAA;EA6FE,sBAAA;EACA,SAAA;AAuBJ;AArBI;EACE,cAAA;AAuBN;;AAlBA;;EAEE,oBAAA;AAqBF;AAnBE;;EACE,eAAA;EACA,YAAA;AAsBJ;AAnBE;;EAjHA,aAAA;EACA,uBAAA;EACA,mBAAA;EAiHE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AAwBJ;;AApBA;EACE,yBAAA;AAuBF;;AApBA;EACE,yBAAA;AAuBF;;AApBA;EAlIE,aAAA;EACA,uBAAA;EACA,mBAAA;EAkIA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AAyBF;AAvBE;EA5IA,aAAA;EACA,uBAAA;EACA,mBAAA;EA4IE,yBAAA;EACA,sBAAA;EACA,QAAA;AA2BJ;AAzBI;EACE,cAAA;AA2BN;AAxBI;EACE,oBAAA;EACA,cAAA;AA0BN;AAtBE;EACE,cAAA;AAwBJ;AArBE;EACE,eAAA;EACA,cAAA;AAuBJ;;AAnBA;EACE,aAAA;EACA,6BAAA;AAsBF;AApBE;EA1KA,aAAA;EACA,uBAAA;EACA,mBAAA;EA0KE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;AAwBJ;;AApBA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,wCAAA;EACA,oCAAA;EACA,cAAA;AAuBF;AArBE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,8FAAA;EACA,+BAAA;EACA,0FAAA;AAuBJ;AArBI;EACE,eAAA;EACA,+BAAA;AAuBN;AAnBE;EACE,qBAAA;AAqBJ;AAlBE;EACE,YAAA;EACA,uCAAA;AAoBJ;AAjBE;EACE,eAAA;AAmBJ;;AAfA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AAkBF","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n@mixin flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container-smart-component {\n  @include external-apparance;\n  padding: 0;\n  padding-block-start: 30px;\n  line-height: 0.9;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.title {\n  @include flex-center;\n  font-size: 50px;\n  font-weight: 700;\n  color: var(--ion-color-primary);\n  background-color: #E9E9E9;\n  padding: 10px;\n  width: 100%;\n  position: relative;\n}\n\n.title::before {\n  content: \"ROOM\";\n  position: absolute;\n  top: -18px;\n  left: 10px;\n  color: #E9E9E9;\n  font-size: 20px;\n}\n\n.container-spinner {\n  @include container-spinenr;\n}\n\n.content {\n  padding: 10px;\n\n  &>*+* {\n    margin-block-start: 40px;\n  }\n\n  .guest {\n    margin-block-start: 10px;\n  }\n}\n\n.date-hour {\n  @include flex-center;\n  gap: 20px;\n  font-size: 20px;\n  margin-block-start: 30px;\n\n  span:first-of-type {\n    color: #BCBCBC;\n  }\n}\n\nion-icon {\n  font-size: 35px;\n  color: #BCBCBC;\n  flex-shrink: 0;\n}\n\n.accesses {\n  @include flex-center;\n  margin-inline: auto;\n  width: calc(100% - 40px);\n  flex-direction: column;\n  border: 1px solid #E9E9E9;\n  border-radius: 10px;\n  padding: 5px 15px;\n\n  &>span {\n    color: #BCBCBC;\n  }\n\n  .access:not(:nth-last-of-type(1)) {\n    border-bottom: 1px solid #E9E9E9;\n  }\n}\n\n.access {\n  @include flex-center;\n  flex-direction: column;\n  align-self: flex-start;\n  gap: 10px;\n  padding: 20px 10px;\n  width: 100%;\n\n  &>span {\n    @include flex-center;\n    align-self: flex-start;\n    gap: 10px;\n\n    &>span {\n      color: #BCBCBC;\n    }\n  }\n}\n\n.enter,\n.leave {\n  text-transform: none;\n\n  ion-icon {\n    font-size: 25px;\n    color: white;\n  }\n\n  &>div {\n    @include flex-center;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    margin-inline-end: 10px;\n  }\n}\n\n.enter>div {\n  background-color: #1FA67B;\n}\n\n.leave>div {\n  background-color: #A61F1F;\n}\n\n.guest {\n  @include flex-center;\n  margin-inline: auto;\n  width: max-content;\n  max-width: calc(100% - 40px);\n  justify-content: flex-start;\n  border: 1px solid #E9E9E9;\n  border-radius: 10px;\n  padding: 5px 10px;\n\n  div {\n    @include flex-center;\n    padding-inline: 30px 40px;\n    flex-direction: column;\n    gap: 3px;\n\n    span:first-of-type {\n      color: #BCBCBC;\n    }\n\n    span:nth-of-type(2) {\n      text-transform: none;\n      color: #787878;\n    }\n  }\n\n  .on {\n    color: #1FA67B;\n  }\n\n  ion-icon {\n    font-size: 45px;\n    color: #A61F1F;\n  }\n}\n\n.buttons {\n  display: flex;\n  justify-content: space-evenly;\n\n  &>div {\n    @include flex-center;\n    flex-direction: column;\n    font-size: 14px;\n    font-weight: 700;\n    gap: 6px;\n  }\n}\n\nion-button {\n  --border-radius: 50%;\n  --padding-start: 0;\n  --padding-end: 0;\n  width: 60px;\n  height: 60px;\n  --background: #E9E9E9;\n  --box-shadow: 0;\n  --ripple-color: var(--ion-color-primary);\n  --transition: transform .2s ease-out;\n  color: #92949c;\n\n  &.button-large {\n    width: 110px;\n    height: 110px;\n    margin-inline: auto;\n    display: block;\n    --background: radial-gradient(circle, rgba(255, 255, 255, 1) 48%, rgba(233, 233, 233, 1) 100%);\n    color: var(--ion-color-primary);\n    --box-shadow: 2px 2px 5px -1px #b3b3b3, 0px 0px 0px 16px #F9F9F9, 0px 0px 8px 18px #EAEAEA;\n\n    ion-icon {\n      font-size: 50px;\n      color: var(--ion-color-primary);\n    }\n  }\n\n  &.active {\n    transform: scale(1.2);\n  }\n\n  &.turn-on {\n    color: white;\n    --background: var(--ion-color-primary)\n  }\n\n  ion-icon {\n    font-size: 45px;\n  }\n}\n\n.toggle-button {\n  display: block;\n  font-size: 24px;\n  cursor: pointer;\n  margin-inline: auto;\n  margin-block-start: 5px;\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
